import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","pa-0":""}},[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,{attrs:{"cols":"12","sm":"8","md":"6"}},[(_vm.title)?_c('div',[_c('h1',{staticClass:"title-style"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()]),_c(VCol,{attrs:{"cols":"12","sm":"4","md":"3","offset-md":"3","align":"end"}},[_vm._t("right-buttons")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }